export default __webpack_public_path__ + "static/media/initiative.7bfac5be.jpg";